import { LightningElement, api } from 'lwc';

import { getCurrentUser, signOut, fetchAuthSession } from 'aws-amplify/auth';

import { get, post } from 'aws-amplify/api';

import {isMobileSetting} from '../../../utils/basicUtils';


const TABLE_COLUMNS = [
    {width: '7%', label: 'Property Name', fieldName: 'property_name', dtype: 'text'},
    {width: '9%', label: 'City', fieldName: 'city', dtype: 'text'},
    {width: '7%', label: 'State', fieldName: 'state', dtype: 'text'},
    {width: '9%', label: 'Zip code', fieldName: 'zip_code', dtype: 'text'},
    {width: '9%', label: 'Country', fieldName: 'country', dtype: 'text'},
    {width: '9%', label: 'Environment Type', fieldName: 'environment_type', dtype: 'text'},
    {width: '11%', label: 'Pool Type', fieldName: 'pool_type', dtype: 'text'},
    {width: '11%', label: 'Restroom Type', fieldName: 'restroom_type', dtype: 'text'},
    {width: '7%', label: 'Max Guests', fieldName: 'max_guests', dtype: 'number'},
    {width: '17%', label: 'Host Email', fieldName: 'email', dtype: 'text'},
    {width: '11%', label: 'Host Phone', fieldName: 'phone', dtype: 'text'},
];

const MOBILE_TABLE_COLUMNS = [
    {width: '33%', label: 'Property Name', fieldName: 'property_name', dtype: 'text'},
    {width: '33%', label: 'City', fieldName: 'city', dtype: 'text'},
    //{width: '12%', label: 'State', fieldName: 'state', dtype: 'text'},
    //{width: '18%', label: 'Pool Type', fieldName: 'pool_type', dtype: 'text'},
    //{width: '18%', label: 'Restroom Type', fieldName: 'restroom_type', dtype: 'text'},
    {width: '33%', label: 'Host Email', fieldName: 'email', dtype: 'text'},
]

export default class gwAdminListingApprovals extends LightningElement {
    _isLoading = false;
    _isAdmin = false;
    _isLoaded = false;

    listingRows = [];

    columns = TABLE_COLUMNS;

    get tableCols() {
        return isMobileSetting() 
            ? MOBILE_TABLE_COLUMNS
            : TABLE_COLUMNS;
    }


    currentViewLabel = 'Pending Approval';
    listViewOptions = [
        { label: 'List Views', 
            options: [
                {label: 'Pending Approval', value: 'Pending Approval'},
                {label: 'Deletion Requests', value: 'Deletion Requests'},
            ]
        }
    ];
    filtersLabel = 'Status: Active';
    sortLabel = 'Created Date';
    settingsOptions = [
        { label: 'Edit List View', value: 'edit' }
    ];
    viewOptions = [
        { label: 'Table', value: 'table' },
        { label: 'Kanban', value: 'kanban' }
    ];
    get listLength() {
        return this.listingRows?.length ?? 0;
    }


    @api 
    set user(val) {
        this._isLoaded = false;
        console.log('here is val in set user() of gwAdminListingApprovals.js: ', JSON.stringify(val));
        this._user = val;
        this._isAdmin = val?.role === 'admin';
        if (this._isAdmin) {
            Promise.resolve().then(async () => {
                await this.loadPendingListings();
                this._isLoaded = true;
            })
        }
    }
    get user() {
        return this._user;
    }

    get tableWrapperCl() {
        return this.listingRows?.length 
            ? 'slds-table-with-header_wrapper'
            : 'slds-table-with-header_wrapper slds-border_bottom';
    }

    async loadDeletionRequests() {
        this._isLoading = true;
        try {
            if (!this.user.idToken) {
                this.showToast('Unauthorized', 'No Id Token was provided', 'error');
                return;
            }
            const op = get({
                apiName: 'api',
                path: '/cognito/admin/listings/delete',
                options: {
                    headers: {
                        Authorization: `Bearer ${this.user.idToken}`
                    }
                }
            });

            const { body } = await op.response;
            const data = await body.json();
            console.log('here is data in loadDeletionRequests() of gwAdminListingApprovals.js: ', data);

            this.listingRows = data.listings || [];

            this.listingIds = (
                data.listings ?? []
            )?.map(listing => listing?.id)
            .filter(Boolean);

        } catch(error) {
            this.showToast('Error in loadDeletionRequests() of gwAdminListingApprovals.js', error, 'error');
        } finally {
            this._isLoading = false;
        }
    }
    async loadPendingListings() {
        this._isLoading = true;
        try {
            if (!this.user?.idToken) {
                this.showToast('Unauthorized', 'No Id Token was provided', 'error');
                return;
            }
            const op = get({
                apiName: 'api',
                path: '/cognito/admin/listings/pending',
                options: {
                    headers: {
                        Authorization: `Bearer ${this.user.idToken}`
                    }
                }
            });

            const { body } = await op.response;
            const data = await body.json();
            console.log('here is data in loadPendingListings() of gwAdminListingApprovals.js: ', data);

            this.listingRows = data.listings || [];

            this.listingIds = (
                data.listings ?? []
            )?.map(listing => 
                listing?.id
            ).filter(Boolean);

        } catch(error) {
            this.showToast('Error in loadPendingListings() of gwAdminListingApprovals.js', error, 'error');
        } finally {
            this._isLoading = false;
        }
    }
    handleNew() {
        console.log('create new clicked');
    }
    
    _noDataHelpText = 'No listings pending approval'
    async handleListViewChange(event) {
        const value = event.detail;
        
        switch(value) {
            case 'Pending Approval':
                await this.loadPendingListings();
                this.currentViewLabel = value;
                this._noDataHelpText = 'No listings pending approval';
                return;
            case 'Deletion Requests':
                await this.loadDeletionRequests();
                this.currentViewLabel = value;
                this._noDataHelpText = `No ${value.toLowerCase()}`;
                return;
            default:
                return;
        }
    }


    async handleApproveClick(event) {
        const listingId = event.currentTarget.dataset.id;
        if (this.currentViewLabel === 'Deletion Requests') {
            await this.approveDeletion(listingId);
        } else {
            await this.approveListing(listingId);
        }
    }
    async handleApproveSelected() {
        const listingIds = this._selectedListings.map(l => l.id);
        if (this.currentViewLabel === 'Deletion Requests') {
            await this.approveDeletion(listingIds);
        } else {
            await this.approveListing(listingIds);
        }
    }

    
    async approveDeletion(listingIds) {
        this._isLoading = true;

        const clndListingIds = Array.isArray(listingIds)
            ? listingIds
            : [listingIds];

        try {
            const op = post({
                apiName: 'api',
                path: '/cognito/admin/listings/delete',
                options: {
                    headers: {
                        Authorization: `Bearer ${this.user.idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        listingIds: clndListingIds
                    }
                }
            });

            const { body } = await op.response;
            return await body.json();

        } catch (error) {
            console.error('approveDeletion error:', error);
            return {
                ok: false,
                error: error?.message || 'Unknown error'
            };
        } finally {
            this._isLoading = false;
        }
    }
    async approveListings(listingIds) {
        const clndListingIds = !Array.isArray(listingIds)
            ? [listingIds]
            : listingIds;
            
        console.log('here is clndListingIds in approveListings of gwAdminListingApprovals.js: ', JSON.stringify(clndListingIds));

        try {
            const op = post({
                apiName: 'api',
                path: '/cognito/admin/listings/approve',
                options: {
                    headers: {
                        Authorization: `Bearer ${this.user.idToken}`,
                        'Content-Type': 'application/json'
                    },
                    body: {
                        listingIds: clndListingIds
                    }
                }
            });

            const { body } = await op.response;
            return await body.json();

        } catch(error) {
            this.showToast('Error in approveListings() of gwAdminListingApprovals.js', error, 'error');
        } 
    }

    async getCheckedListingIds() {
        const table = this.template.querySelector('x-slds-table');
        if (!table || typeof table.getCheckedRows !== 'function') {
            return [];
        }

        const checkedRows = await table.getCheckedRows();
        return Array.isArray(checkedRows)
            ? checkedRows.filter(id => this.listingIds.includes(id))
            : [];
    }

    async clearCheckedRows() {
        const table = this.template.querySelector('x-slds-table');
        if (!table) return;

        if (typeof table.resetCellClasses === 'function') {
            await table.resetCellClasses();
            return;
        }

        if (typeof table.clearCheckboxes === 'function') {
            await table.clearCheckboxes();
        }
    }

    async deleteSelectedListings(listingIds) {
        const resp = await this.approveDeletion(listingIds);
        const deletedIds = resp?.deletedIds ?? [];

        if (!deletedIds.length) {
            this.showToast('No listings were deleted.', resp?.error || '', 'error');
            return;
        }

        const lbl = deletedIds.length === 1 ? 'Listing' : 'Listings';
        this.showToast(`${deletedIds.length} ${lbl} successfully deleted.`, '', 'success');
        this.listingRows = this.listingRows.filter(listing => !deletedIds.includes(listing.id));
        this.listingIds = this.listingIds.filter(id => !deletedIds.includes(id));
        await this.clearCheckedRows();
    }

    modalConfig;
    async handleHeaderButtonClick(message) {
        try {
            const buttonLabel = message.detail;
            console.log('here is buttonLabel in handleHeaderButtonClick(): ', buttonLabel);
            this._isLoading = true;
            if (
                buttonLabel === 'Approve Selected' || 
                buttonLabel === 'Delete Selected'
            ) {
                const checkedListingIds = await this.getCheckedListingIds();

                if (!checkedListingIds.length) {
                    this.showToast('No listings selected.', 'Select one or more rows first.', 'error');
                    return;
                }

                if (buttonLabel === 'Approve Selected') {
                    const resp = await this.approveListings(checkedListingIds);
                    console.log('here is resp in approveListings() of gwAdminListingApprovals.js: ', resp);
                    const approvedIds = resp?.approvedIds ?? [];
                    const lbl = approvedIds?.length === 1 ? 'Listing' : 'Listings';
                    this.showToast(`${approvedIds?.length ?? '0'} ${lbl} successfully approved.`, '', 'success');
                    this.listingRows = this.listingRows.filter(lst => !approvedIds.includes(lst.id));
                    this.listingIds = this.listingIds.filter(id => !approvedIds.includes(id));
                    await this.clearCheckedRows();
                } else {
                    this.modalConfig = {
                        modalTitle: 'Delete Listing Submissions',
                        message: `Are you sure you want to delete ${checkedListingIds.length} listings?`,
                        messageNext: 'This action cannot be undone.',
                        listingIds: checkedListingIds
                    }
                }

            }
            else {
                console.log('button did not equal Approve Selected Listings');
            }
        } catch(error) {
            this.showToast('Error in handleHeaderButtonClick() of gwAdminListingApprovals.js', error, 'error');
        } finally {
            requestAnimationFrame(() => {
                this._isLoading = false;
            });
        }
    }

    async confirmDeletions() {
        this._isLoading = true;
        try {
            const listingIds = this.modalConfig.listingIds;
            if (listingIds?.length) {
                await this.deleteSelectedListings(listingIds);
            }
        } catch(error) {
            this.showToast('Error in confirmDeletions() of gwAdminListingApprovals.js', error, 'error');
        } finally {
            this._isLoading = false;
        }
    }
    closeModal() {
        this.modalConfig = null;
    }


    async handleViewRecentlyApproved() {
        console.log('view recently approved');
    }


    get approvalButton() {
        if (this.currentViewLabel === 'Deletion Requests') {
            return {
                cl: 'slds-button slds-button_destructive',
                label: null
            }
        }
        return {
            cl: 'slds-button slds-button_neutral',
            label: 'Approve Selected'
        };
    }

    toastObj;
    showToast(title, message, variant, mode=null) {
        const modeP = mode 
            ? mode 
                : variant === 'success'
            ? 'dismissible'
            : 'sticky';
        
        this.toastObj = { 
            variant: variant, 
            mode: modeP, 
            message: message,
            header: { 
                text: title
            }        
        };
    }
}
